import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ScheduledCommand } from "../Model/ScheduledCommand";

export async function disableScheduledCommand(id) {
	let response = await getAPIResponse("/command-scheduler/scheduled-command/"+id+"/disable", {}, "PUT");
	if (response === null) {
		return null;
	}
	let scheduledCommand = ScheduledCommand.createFromResponseData(response);
	return scheduledCommand;
}